import { useState, useEffect } from 'react';

/**
 * Custom hook to track scroll position
 * Returns the current Y scroll position
 * Updates on scroll with throttling for performance
 */
export const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      // Throttle scroll events for better performance
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        setScrollPosition(window.scrollY);
      }, 10);
    };

    // Set initial scroll position
    setScrollPosition(window.scrollY);

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return scrollPosition;
};
